/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueGuidModel } from '../../models/key-value-guid-model';

export interface DashboardClientListPublisherIdGet$Plain$Params {
  publisherId: string;
}

export function dashboardClientListPublisherIdGet$Plain(http: HttpClient, rootUrl: string, params: DashboardClientListPublisherIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
  const rb = new RequestBuilder(rootUrl, dashboardClientListPublisherIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('publisherId', params.publisherId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueGuidModel>>;
    })
  );
}

dashboardClientListPublisherIdGet$Plain.PATH = '/Dashboard/ClientList/{publisherId}';
